<template>
  <EditBox :name="name" :styleList="styleList" :currentStyle.sync="localStyle" :tip="'分割线设置'">
    <ItemSetting label="线条颜色">
      <el-color-picker v-model="color" show-alpha></el-color-picker>
    </ItemSetting>
    <ItemSetting label="线条宽度">
      <el-input type="number" placeholder="请输入线条宽度" v-model.number="lineWidth"></el-input>
    </ItemSetting>
  </EditBox>
</template>

<script>
import EditBox from "./box/EditBox";
import ItemSetting from "./setting/ItemSetting";
import editMixin from './mixins/editMixin';

export default {
  name: 'DividerEdit',
  mixins: [editMixin],
  components: {
    EditBox,
    ItemSetting
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    styleList: {
      type: Array,
      default: () => []
    },
    currentStyle: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    color: {
      get() {
        return this.value.color
      },
      set(val) {
        this.updateValue({ color: val })
      }
    },
    lineWidth: {
      get() {
        return this.value.lineWidth
      },
      set(val) {
        if (!val) {
          val = 1
        }
        if (val < 1) {
          this.$message.error('线条宽度必须大于等于1')
          return
        }
        this.updateValue({ lineWidth: val })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
